"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureAllTimeFilterForExport = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
// the value is taken from gdc-dashboards
var allTimeFilterContextItem = {
    dateFilter: {
        type: "absolute",
        granularity: "GDC.time.year",
    },
};
function ensureAllTimeFilterForExport(filters) {
    // if there is no date filter, add an "all time" filter so that in case the dashboard is saved with some
    // date filter, it is overridden to All time for the purpose of the export
    return filters.some(sdk_model_1.isDashboardDateFilter) ? filters : tslib_1.__spread([allTimeFilterContextItem], filters);
}
exports.ensureAllTimeFilterForExport = ensureAllTimeFilterForExport;
//# sourceMappingURL=filterUtils.js.map